import type { ScreenContext } from './types.ts';
import { createMoodSlider } from '@/components/mood-slider.ts';
import { createContinueButton, setButtonLoading } from '@/components/continue-button.ts';
import { addMoodCheckin } from '@/api/operations.ts';
import { getClipForIndex } from './helpers.ts';

export function renderClipCheckin(container: HTMLElement, ctx: ScreenContext) {
  const { state, dispatch } = ctx;
  const startedAt = performance.now();

  container.innerHTML = `
    <div class="card space-y-6">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">After clip ${state.clipIndex}</p>
        <h2 class="text-2xl font-semibold text-gray-900">How do you feel now?</h2>
        <p class="text-gray-700 mt-1">Slide to record your mood.</p>
      </div>
      <div id="slider-slot"></div>
      <div id="action-slot"></div>
    </div>
  `;

  const slider = createMoodSlider('clip-checkin', 'Stress level after clip', 5,true);
  container.querySelector('#slider-slot')?.appendChild(slider.root);

  const btn = createContinueButton('Continue');
  container.querySelector('#action-slot')?.appendChild(btn);

  btn.addEventListener('click', async () => {
    setButtonLoading(btn, true, 'Continue', 'Saving...');
    const mood = slider.getValue();
    const durationMs = Math.round(performance.now() - startedAt);
    const clip = getClipForIndex(state);
    const label = clip
      ? (() => {
          const tag = clip.emotionTag?.trim();
          if (!tag) return clip.title;
          const hasTagInTitle = clip.title.toLowerCase().includes(tag.toLowerCase());
          return hasTagInTitle ? clip.title : `${clip.title} (${tag})`;
        })()
      : undefined;
    dispatch({ type: 'ADD_CLIP_CHECKIN', payload: { mood, label } as any });

    if (state.sessionId) {
      try {
        await addMoodCheckin({
          sessionId: state.sessionId,
          checkinType: 'clip',
          sequenceIndex: state.clipCheckins.length + 1,
          clipIndex: state.clipIndex,
          silenceIndex: null,
          moodValue: mood,
          durationMs,
        });
      } catch (error) {
        console.error('Failed to persist clip check-in', error);
      }
    }

    dispatch({ type: 'NEXT_PHASE' });
    setButtonLoading(btn, false, 'Continue');
  });
}
